module.exports = __webpack_public_path__ + "static/media/apz.4bf247d7.jpg";